import { defineComponent as _defineComponent } from 'vue';
import variables from '@vab/styles/variables/variables.module.scss';
import { useRoutesStore } from '@/store/modules/routes';

import { storeToRefs } from 'pinia';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    layout: {
      type: String,
      default: 'horizontal'
    }
  },
  setup(__props, {
    expose: __expose
  }) {
    __expose();
    const routesStore = useRoutesStore();
    const {
      getActiveMenu: activeMenu,
      getRoutes: routes
    } = storeToRefs(routesStore);
    const __returned__ = {
      routesStore,
      activeMenu,
      routes,
      get variables() {
        return variables;
      }
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
});